import { Column } from '@atom-web/micros'
import Scroll from 'react-scroll'
import styled from 'styled-components'

const Link = Scroll.Link

const TabWrapper = styled('ul')`
	padding-left: 0;
	list-style: none;
	margin: 0;
	white-space: nowrap;
	overflow-x: auto;
	overflow-y: hidden;

	li {
	  display: inline-block;
	  margin-right: 40px;
	  cursor: pointer;
	  position: relative;
	  transition: all 0.5s ease;
    
	  &:last-child {
		margin-right: 0;
	  }
	  a {
		color: #888888;
		font-size: 15px;
		line-height: 20px;
		font-weight: 600;
		margin: 12px 0;
		height: 100%;
		display: inline-block;
	  }
  
	  a:after {
		content: '';
		display: block;
		width: 0;
		height: 3px;
		background-color: transparent;
		transition: all 0.5s ease;
		position: absolute;
		bottom: 0;
		color: #00B277;
  	  }
      
	  &:hover,
	  &:hover a,
	  a.active {
		color: #00B277;
		font-weight: 600;
  
		&:after {
		  width: 100%;
		  background-color: #00B277;
		  border-radius: 8px 8px 0px 0px;
		  margin-bottom:4px;
		}
	  }
  	}
  }
`

const ScrollSpyTabs = ({
	tabs,
	setActiveIcon,
	// onscroll
}) => {
	// const setActive = useMemo(
	// 	data => {
	// 		if (onscroll == false) {
	// 			setActiveIcon('')
	// 		}
	// 	},
	// 	[onscroll],
	// )
	return (
		<TabWrapper>
			{tabs.map(({ name, key, icon, onclick, ...rest }, inx) => {
				return (
					<li key={`list-tab-${inx}`}>
						<Link
							onSetActive={data => setActiveIcon && setActiveIcon(data)}
							to={key}
							spy={true}
							smooth={true}
							duration={500}
							{...rest}
							onClick={onclick}
						>
							<Column
								align="center"
								gap={'1'}
								css={{
									fontSize: '$2',
									'@lg': {
										paddingTop: '12px',
										fontSize: '17px',
									},
								}}
							>
								{icon && icon}
								{name}
							</Column>
						</Link>
					</li>
				)
			})}
		</TabWrapper>
	)
}

export default ScrollSpyTabs
